import Guid from "~/helpers/guid";
import { INavigableValidatableModel } from "../../../../common/interfaces/navigableValidationInterfaces";
import IRepo from "../../../../common/interfaces/repo";
import Validatable from "../../../../common/mixins/validatable";
import FormBuilderModel from "../../../../common/models/tracked/formBuilderModel";
import Repo from "../../../../common/state/modules/repo";
import FormElement from "../formElements/formElement";
import WorkflowStep from "../workflow/workflowStep";

export default class UserDefinedField extends Validatable(FormBuilderModel) implements INavigableValidatableModel<WorkflowStep> {
  udf_field: string;
  udf_field_formula: string;
  sort_order: number;

  static repo: IRepo<UserDefinedField> = new Repo<UserDefinedField>('userDefinedFields', UserDefinedField);

  constructor(parent, json) {
    super();
    this.parent = parent;
    this.defineProperty('client_id', Guid.create());
    this.defineProperty('udf_field_formula', json["udf_field_formula"] || "")
    this.defineProperty('sort_order', json["sort_order"] || 0)
  }

  //******************** VALIDATABLE ********************//
  // _validation: PaymentLineItemValidation = new PaymentLineItemValidation(this);

  getDisplayName(propName: string, value?): string {
    switch (propName) {
      default:
        return propName;
    }
  }
  //******************** VALIDATABLE END ********************//

  get rootName(): string {
    return 'user_defined_fields';
  }

  get elementName(): string {
    return 'user_defined_field';
  }

  getReferencedControl(id: string): FormElement {
    return FormElement.repo.find(id);
  }

  getReferencableControls(): FormElement[] {
    return this.rootModel.referenceableFormElementsFor(null);
  }
}